import React, { useEffect, useState } from 'react';

// import FooterV1 from "./FooterV1";
// import FooterV2 from "./v2/FooterV2";
import FooterV3 from "./v3/Footer";

const Footer = () => {
    return (
        ""
    );
}

export default Footer;
